/**
 * Uncanny Coupon Login
 *
 * @author Uncanny Owl
 * @version 1.0.0
 */

jQuery(document).ready(function ($) {
    $("#coupon-length").keypress(function (e) {
        if (e.which === 10 || e.which === 13) {
            e.preventDefault();
        }
    });

    $('.uo-btn-delete').on('click', function (e) {
        if (!confirm(uoCodesStrings.Doyoureallywanttodeletethesecodes)) e.preventDefault();
    });

    $('.uo-btn-delete-code').on('click', function (e) {
        if (!confirm(uoCodesStrings.Doyoureallywanttodeletethiscode)) e.preventDefault();
    });

    $('.uo-btn-replace').on('click', function (e) {
        if (!confirm(uoCodesStrings.Doyoureallywanttoreplacethiscode)) e.preventDefault();
    });

    $('.uo-btn-cancel').on('click', function (e) {
        if (!confirm(uoCodesStrings.Doyoureallywanttocancelthiscode)) e.preventDefault();
    });

    render_code();

    $("input[name='coupon-length'], input[name='coupon-prefix'], input[name='coupon-suffix'], input[name='coupon-dash']").on( 'input', function (e) {
        render_code();
    });

    $("input[type=checkbox][name='coupon-character-type[]']").change(function (e) {
        render_code();
    });

    function render_code(returnCode = false) {
        if ( $( '#uoc-generate-code-preview-fake-code' ).length > 0 ){
            var chars = uoCodesStrings.avail_characters,
                dashes = $("input[name='coupon-dash']").val(),
                coupon_length = $("input[name='coupon-length']").val(),
                prefix = $("input[name='coupon-prefix']").val(),
                prefix_length = prefix.length,
                suffix = $("input[name='coupon-suffix']").val(),
                suffix_length = suffix.length,
                random_string = '';

            var code_char_type = $("input[type=checkbox][name='coupon-character-type[]']:checked").map(function(){
                return $(this).val();
            }).get();

            if( $.inArray('lowercase-letters',code_char_type) == -1 ){
                chars = chars.replace('abcdefghjkmnpqrstuvwxyz','');
            }

            if( $.inArray('uppercase-letters',code_char_type) == -1 ){
                chars = chars.replace('ABCDEFGHJKLMNPQRSTUVWXYZ','');
            }

            if( $.inArray('numbers',code_char_type) == -1 ){
                chars = chars.replace('123456789','');
            }
            if( chars.length == 0 ){
                chars = '123456789ABCDEFGHJKLMNPQRSTUVWXYZ';
            }
            coupon_length = coupon_length - prefix_length - suffix_length;

            for (var i = 0; i < coupon_length; i++) {
                var rnum = Math.floor(Math.random() * chars.length);
                random_string += chars.substring(rnum, rnum + 1);
            }

            var strings = prefix + random_string + suffix;

            if (dashes) {
                dashes = dashes.split('-');
                var strings_arr = strings.split(''),
                    new_string = '',
                    dash_inside_pointer = 0,
                    dash_index = 0;

                $(strings_arr).each(function (i) {
                    new_string = new_string + $(this)[0];
                    dash_inside_pointer++;

                    if (dashes[dash_index] <= dash_inside_pointer) {
                        dash_index++;
                        dash_inside_pointer = 0;
                        new_string = new_string + "-";
                    }
                });

                if (new_string.substring(new_string.length - 1, new_string.length) == "-") {
                    new_string = new_string.substring(0, new_string.length - 1);
                }
            } else {
                var new_string = strings;
            }
            if (returnCode) {
                return new_string;
            } else {
                $("#uoc-generate-code-preview-fake-code").html(new_string);
            }
        }
    }

    function change_assign_form() {
        if ($("#uncanny_form_input_vendor #assign_where").val() == "courses") {
            $("#uncanny_form_input_vendor #assign_courses").show();
            $("#uncanny_form_input_vendor #assign_lessons").hide();

        } else {
            $("#uncanny_form_input_vendor #assign_courses").hide();
            $("#uncanny_form_input_vendor #assign_lessons").show();
        }
    }

    if ($("#uncanny_form_input_vendor #assign_where").length) {
        change_assign_form();

        $("#uncanny_form_input_vendor #assign_where").change(function () {
            change_assign_form();
        });
    }

    $("#page_coupon_stat .btn_delete, #page_coupon_stat .btn_delete").click(function (e) {
        if (!confirm(uoCodesStrings.Doyoureallywanttodeletethis)) e.preventDefault();
    });

    // Prefix Selector for View Coupon by Group
    $('#prefix_selector_for_coupon_group').change(function () {
        if ($(this).val()) {
            location.href = add_query_arg('prefix', $(this).val());
        } else {
            location.href = remove_query_arg('prefix');
        }
    });

    $('#badge_selector_for_coupon_group').change(function () {
        if ($(this).val()) {
            location.href = add_query_arg('badge_id', $(this).val());
        } else {
            location.href = remove_query_arg('badge_id');
        }
    });
});

function add_query_arg(key, value, url) {
    if (!url) url = location.href;

    key = escape(key);
    value = escape(value);

    if (!value) return remove_query_arg(key, url);

    var pair = key + "=" + value;
    var exp = new RegExp("(&|\\?)" + key + "=[^\&]*");
    url = url.replace(exp, "$1" + pair);

    if (url.indexOf(key + '=') > -1) {
    } else {
        if (url.indexOf('?') > -1) {
            url += '&' + pair;
        } else {
            url += '?' + pair;
        }
    }

    return url;
}

function remove_query_arg(key, url) {
    if (!url) url = location.href;

    key = escape(key);

    var exp = new RegExp("(&|\\?)" + key + "=[^\&]*");
    url = url.replace(exp, '');

    return url;
}

jQuery.fn.regexMask = function (mask) {
    jQuery(this).keypress(function (event) {
        if (!event.charCode) return true;
        var part1 = this.value.substring(0, this.selectionStart);
        var part2 = this.value.substring(this.selectionEnd, this.value.length);
        if (!mask.test(part1 + String.fromCharCode(event.charCode) + part2))
            return false;
    });
};

jQuery(document).ready(function () {
    var mask = new RegExp('^[A-Za-z0-9]*$')
    jQuery("input.regex-alphanumeric").regexMask(mask)
});
